import AttendanceAdapter from './base';

export default class Suspension extends AttendanceAdapter {
  modelNamePlural = 'suspensions';
}
